/*eslint lodash/prefer-includes:0*/
export default function runEditor(window, packagesStructure, requirejs, editorModel, queryUtil, config, shouldRender = true, measureFrameRate = true, logger) {
    const packagesArr = ['santa-editor-symbols', 'rEditor', 'compPanelInfra', 'core', 'tpa',
        'util', 'zepto', 'react', 'reactDOM', 'lodash', 'tslib', 'superAppMenuInfra',
        'savePublish', 'panels', 'experiment', 'staticAssets', 'textControls', 'mediaFrame', 'keyboardMaster',
        'baseUI', 'uiAnimations', 'panelUtils', 'mediaServices', 'color', 'pms', 'databaseEditor', 'json',
        'gfppData', 'backgroundPresets', 'styles', 'pagesMenu', 'popups']

    if (queryUtil.isParameterTrue('isqa')) {
        packagesArr.push('qaAutomation', 'debugTools')
    }
    if (queryUtil.isParameterTrue('isTpaIntegration')) {
        packagesArr.push('tpaIntegrationEditor', 'jasmine', 'jasmine-html')
    }
    if (queryUtil.isParameterTrue('isUiLibIntegration')) {
        packagesArr.push('uiLibIntegrationEditor', 'jasmine', 'jasmine-html')
    }
    if (queryUtil.isParameterTrue('isPlatformIntegration')) {
        packagesArr.push('platform', 'platformIntegrationEditor', 'jasmine', 'jasmine-html')
    }

    let onError = errorHandler

    const prefetch = window.isPrefetchMode ||
        window.location.pathname.indexOf('prefetch') > 0 ||
        queryUtil.isParameterTrue('prefetch')

    let languagePackageName
    if (prefetch) {
        packagesArr.push('addPanelData', 'addPanelInfra', 'addPanel', 'addPanelDataConsts', 'addPanelSectionsEN')

        const languageCode = window.editorModel && window.editorModel.languageCode
        languagePackageName = languageCode && `addPanelSections${languageCode.toUpperCase()}`
        const existsInPackagesStructure = packagesStructure.indexOf(languagePackageName) !== -1
        const existsInPackagesArr = packagesArr.indexOf(languagePackageName) !== -1
        const isSupportedAddPanelLanguage = !!config.paths[languagePackageName]
        if (!existsInPackagesStructure && !existsInPackagesArr && isSupportedAddPanelLanguage) {
            packagesArr.push(languagePackageName)
        }

        // Preload scripts for caching
        if (window.define) {
            onError = function () {}
            const plugins = {
                json: true,
                text: true,
                experiment: true
            }
            const dummy = () => ({})
            const define = window.define
            window.define = function (name) {
                const args = Array.apply(null, arguments)
                if (!plugins.hasOwnProperty(name) && name !== 'zepto') {
                    for (let i = 1; i < args.length; ++i) {
                        if (typeof args[i] === 'function') {
                            args[i] = dummy
                        }
                    }
                }
                return define.apply(this, args)
            }
            window.define.amd = define.amd
        }
    }

    if (window.define) {
        window.define('bluebird', [], () => Promise)
        window.define('requirejs', [], () => requirejs)
    }

    function errorHandler(err) {
        if (!config.urlArgs) {
            if (err.requireModules) {
                err.requireModules.forEach(module => {
                    requirejs.undef(module)
                })
            }
            config.urlArgs = `c=${Date.now()}`
            requirejs.config(config)
            requirejs(packagesArr, () => {
                err.errn = 'REQUIREJS_RETRY_ERROR'
                err.errc = 111025
                err.severity = 10
                requirejs.onError(err)
            }, error => {
                requirejs.onError(error)
            })
        }
    }

    const _onError = queryUtil.getParameterByName('debug') ? undefined : onError

    function buildFunctionParametersObject(_pkgs, args) {
        return _pkgs.reduce((result, pkg, index) => {
            result[pkg.replace(/^.*:/, '')] = args[index]
            return result
        }, {})
    }

    return new Promise(resolve => {
        requirejs(packagesArr, function () {
            if (prefetch) {
                return
            }
            const p = buildFunctionParametersObject(packagesArr, arguments)

            if (languagePackageName) {
                p.addPanel.sections.applyTranslatedSections(p[languagePackageName])
            }

            const builtEditor = p.rEditor.editorMain.build(p, measureFrameRate, logger)
            if (shouldRender) {
                p.rEditor.editorMain.render(builtEditor, logger)
            }
            resolve(builtEditor)
        }, _onError)
    })
}
